const DASHBOARD_TITLE_SUFFIX = " - Paymish Dashboard";

const ROUTE_TITLE_MAP: Array<{ pattern: RegExp; title: string }> = [
  { pattern: /^$/, title: "Dashboard" },
  { pattern: /^dashboard$/, title: "Dashboard" },
  { pattern: /^auth\/login$/, title: "Login" },
  { pattern: /^auth\/forgot-password$/, title: "Forgot Password" },
  { pattern: /^auth\/reset-password\/[^/]+$/, title: "Reset Password" },
  { pattern: /^auth\/sign-up$/, title: "Sign Up" },
  { pattern: /^pay\/[^/]+$/, title: "Payment Link" },
  { pattern: /^checkout\/[^/]+$/, title: "Checkout" },
  { pattern: /^buy\/[^/]+$/, title: "Product Preview" },
  { pattern: /^digitalproducts\/[^/]+$/, title: "Download Product" },
  { pattern: /^team\/join-team$/, title: "Join Team" },
  { pattern: /^transaction-status$/, title: "Transaction Status" },
  { pattern: /^terms$/, title: "Terms of Service" },
  { pattern: /^dispute(\/.*)?$/, title: "Dispute" },
  { pattern: /^transaction\/details\/[^/]+$/, title: "Transaction Details" },
  { pattern: /^transaction(\/.*)?$/, title: "Transactions" },
  { pattern: /^transfer\/details\/[^/]+$/, title: "Transfer Details" },
  { pattern: /^transfer\/new$/, title: "New Transfer" },
  { pattern: /^transfer\/bulk-upload\/review$/, title: "Bulk Transfer Review" },
  { pattern: /^transfer\/bulk-upload$/, title: "Bulk Transfer Upload" },
  { pattern: /^transfer(\/.*)?$/, title: "Transfers" },
  { pattern: /^recipient\/details\/[^/]+$/, title: "Recipient Details" },
  { pattern: /^recipient(\/.*)?$/, title: "Recipients" },
  { pattern: /^customer\/details\/[^/]+$/, title: "Customer Details" },
  { pattern: /^customer(\/.*)?$/, title: "Customers" },
  { pattern: /^invoice\/details\/[^/]+$/, title: "Invoice Details" },
  { pattern: /^invoice(\/.*)?$/, title: "Invoices" },
  { pattern: /^refund\/details\/[^/]+$/, title: "Refund Details" },
  { pattern: /^refund(\/.*)?$/, title: "Refunds" },
  { pattern: /^disputes\/detail\/[^/]+$/, title: "Dispute Details" },
  { pattern: /^disputes(\/.*)?$/, title: "Disputes" },
  { pattern: /^payout\/details\/[^/]+$/, title: "Payout Details" },
  { pattern: /^payout(\/.*)?$/, title: "Payouts" },
  { pattern: /^balance$/, title: "Balance" },
  { pattern: /^plans?(\/.*)?$/, title: "Plans" },
  { pattern: /^product\/details\/[^/]+$/, title: "Product Details" },
  { pattern: /^product(\/.*)?$/, title: "Products" },
  { pattern: /^sub-account-new(\/.*)?$/, title: "New Subaccount" },
  { pattern: /^sub-account(\/.*)?$/, title: "Subaccounts" },
  { pattern: /^subscription(\/.*)?$/, title: "Subscriptions" },
  { pattern: /^subscriber(\/.*)?$/, title: "Subscribers" },
  { pattern: /^utility(\/.*)?$/, title: "Utility" },
  { pattern: /^setting(\/.*)?$/, title: "Settings" },
  { pattern: /^settings(\/.*)?$/, title: "Settings" },
  { pattern: /^profile$/, title: "Profile" },
  { pattern: /^change-password$/, title: "Change Password" },
  { pattern: /^logout$/, title: "Logout" },
  { pattern: /^new-business$/, title: "New Business" },
  { pattern: /^pages$/, title: "Pages" },
];

function normalizeUrlPath(url: string): string {
  return (url || "")
    .split("?")[0]
    .split("#")[0]
    .replace(/^\/+|\/+$/g, "");
}

function titleizeSegment(segment: string): string {
  return segment
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatDashboardTitle(pageTitle?: string): string {
  const trimmedTitle = (pageTitle || "").trim();
  return trimmedTitle ? `${trimmedTitle}${DASHBOARD_TITLE_SUFFIX}` : "Paymish Dashboard";
}

export function resolveDashboardPageTitle(url: string): string {
  const path = normalizeUrlPath(url);

  for (const entry of ROUTE_TITLE_MAP) {
    if (entry.pattern.test(path)) {
      return entry.title;
    }
  }

  const [firstSegment, secondSegment] = path.split("/").filter(Boolean);

  if (!firstSegment) {
    return "Dashboard";
  }

  if (firstSegment === "auth") {
    return titleizeSegment(secondSegment || "auth");
  }

  if (firstSegment === "team") {
    return titleizeSegment(secondSegment || "team");
  }

  return titleizeSegment(firstSegment);
}
